export const my = {
    "TRIGGER_LISTEN": "အကြောင်းပြုချက်များကို နားထောင်နေသည်",
    "ASSIST_EMPTY_MSG": "အေဂျင် AI သင်၏အပြောအဆိုကို နားထောင်နေသည်။ အကြောင်းပြုချက်များတက်ကြွသည့်အခါ အလိုအလျောက် ကူညီရန် ပြင်ဆင်ထားသည်။",
    "MYBOT_TRIGGET_LISTEN": "လက်ရှိတွင် My Bot အလုပ်များမရှိပါ",
    "MYBOT_EMTPY_MSG": "My Bot တွင် အလုပ်စတင်ရန်၊ ရှာဖွေရန်အတန်းသို့ သွားပြီး သင့်လိုအပ်သော အလုပ်အတွက် \"အေဂျင်ထည့်သွင်းမှုများနှင့် လုပ်ပါ\" အထွက်ကို ရွေးပါ။",
    "PROACTIVE_MODE": "အကောင့်ကျင့်သုံးမှုမူလ",
    "SETTINGS": "အဆင့်သတ်မှတ်ချက်များ",
    "HELP_AND_SUPPORT": "အကူအညီနှင့် ထောက်ပံ့မှု",
    "HELP": "အကူအညီ",
    "LANGUAGE": "ဘာသာစကား",
    "THEME": "သီမ်",
    "AUTOMATIC": "အလိုအလျောက်",
    "AUTO_SCROLL_TOOLTIP":"အကူအညီတိုက်, ငါ့ဘော့နှင့် ဇာတ်ကြောင်းတိုက်အကြောင်းအရာများကို အလိုအလျှောက်လှိမ့်ခေါ်မှုကို ထိန်းချုပ်သည်",
    "DARK": "အမှောင်",
    "LIGHT": "အလင်း",
    "THEME_DESC": "ဤသည် သင့်စက်ပုံစံအလိုအလျောက် သည်ဖြစ်ပါသည်",
    "DOCUMENTATION": "စာရွက်စာတမ်း",
    "DOC_DESC": "ကျွန်ုပ်တို့၏ အဆင်ပြေလျှောက်ထားစာမျက်နှာများကို ကြည့်ပါ။",
    "FAQ_U": "အမြဲမေးခွန်းများ",
    "FILE_NAME":"ဖိုင်အမည်",
    "FAQ_DESC": "အေဂျင် AI အကြောင်း မေးခွန်းများကို ကြည့်ပါ။",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "အေဂျင် AI အကြောင်း သင်ခန်းစာများကို ကြည့်ပါ။",
    "SEARCH": "ရှာဖွေရန်",
    "MY_BOT": "My Bot",
    "TAB_TEXT":"တဘ်များမဖွင့်ထားပါ! ကျေးဇူးပြု၍ အနည်းဆုံးတစ်ခုဖွင့်ပါ",
    "ASSIST": "ကူညီ",
    "TRANSCRIPT": "စာတို",
    "HISTORY": "သမိုင်း",
    "STARTOVER": "ပြန်စသည်",
    "RESTART_INPUTS": "ဖမ်းယူထားသော အချက်အလက်များနှင့် ပြန်စသည်",
    "TAP_SEARCH":"ရှာဖွေရန် တို့ပါ",
    "ASKCUSTOMER": "ဖောက်သည်ကို မေးပါ",
    "TELLCUSTOMER": "ဖောက်သည်ကို ပြောပါ",
    "WELCOME_MSG": "ကြိုဆိုသော အစီအစဉ်",
    "SEND": "ပို့ပါ",
    "SENT": "ပို့ပြီး",
    "AWAITING": "တုံ့ပြန်မှုကို မေတ္တာနှင့် စောင့်နေပါသည် | ဆက်ရန်ရိုက်ပါ",
    "OVERRIDE": "ဆက်ရန်ရိုက်ပါ",
    "OVERRIDE_FILE": "ဆက်ရန် ဖိုင်တင်ပါ",
    "ACCEPT_RESPONSE": "တုံ့ပြန်မှုကို လက်ခံပါ",
    "AGENT_ENTERED": "အေဂျင်ဝင်ရောက်ခဲ့သည်",
    "EXPECTED_FORMAT": "မျှော်မှန်းထားသော ဖွဲ့စည်းမှု",
    "INPUT_VALUES": "ထည့်သွင်းမှု တန်ဖိုးများ",
    "RESTART": "ပြန်စသည်",
    "START_OVER": "ပြန်စသည်",
    "RESTART_CAPTURE": "ဖမ်းယူထားသော အချက်အလက်များနှင့် ပြန်စသည်",
    "CANCEL": "မလုပ်ပါ",
    "INTERRUPT_DIALOG": "စကားပြောမှု အလုပ်ကို မပြတ်",
    "RUN": "ရန်",
    "RUN_AGENT": "အေဂျင်ထည့်သွင်းမှုနှင့် လုပ်ပါ",
    "STEP": "အဆင့်",
    "DIALOG_TASK": "စကားပြောမှု အလုပ်",
    "FAQ": "အမြဲမေးခွန်းများ",
    "SNIPPET": "တုံ့ပြန်ချက်များ",
    "ARTICLE": "ဝက်ဘ်စာမျက်နှာများ",
    "FILE": "ဖိုင်",
    "SUGGESTED": "အကြံပြု",
    "ALL_DIALOG": "အစီအစဉ်အားလုံး",
    "DIALOG_TEXT": "စကားပြော",
    "INTENT_IDENTIFIED": "ဖောက်သည်တို့၏ သဘောထား",
    "NOT_WHAT_LOOKING": "မမှန်သလား?",
    "BOT": "Bot",
    "CUSTOMER": "ဖောက်သည်",
    "YOU": "သင့်",
    "TERMINATE_CONV": "စကားပြောမှု အလုပ်ကို ရပ်ဆိုင်းပါ",
    "TERMINATE_CONV_DESC": "စကားပြောမှု အလုပ်ကို ရပ်ဆိုင်းမလား? အေဂျင် AI သည် အကြံပြုမှုများပြန်လည်ပြောစကား မရနိုင်တော့ပါ။",
    "YES_TERMINATE": "ဟုတ်ကဲ့ ရပ်ဆိုင်းပါ",
    "NO_CANCEL": "မဟုတ်ပါ၊ မလုပ်ပါ",
    "OVERRIDE_CONTINUE": "အသစ်အဖြစ် ဆက်လက်လုပ်ပါ",
    "SUMMARY_TEXT": "အကျဉ်းချုပ်",
    "SUBMIT": "ပေးပို့ပါ",
    "INTERRUPT_OCCURED": "အနှောက်အယှက်ဖြစ်ခဲ့သည်",
    "IDENTIFIED_INTENT": "သိရှိထားသော သဘောထား",
    "INTERRUPT_DESC": "ဤကို ပြုလုပ်သည်က စကားပြောမှု အလုပ်ကို ရပ်ဆိုင်းစေမည်။",
    "ACCEPT_RUN": "လက်ခံပြီး ပြုလုပ်ပါ",
    "RUN_LATER": "နောက်မှ ပြုလုပ်ပါ",
    "KNOW_MORE": "ပို၍ သိရှိပါ",
    "MORE_TEXT": "ပိုမို",
    "LESS_TEXT": "ပိုမို",
    "VIEW_MORE": "ပိုမို ကြည့်ပါ",
    "VIEW_LESS": "ပိုမို မကြည့်ပါ",
    "SHOW_MORE_FAQ": "ပိုမို ရှင်းလင်းသော အမြဲမေးခွန်းများ",
    "SHOW_LESS_FAQ": "ငယ်ရွယ်သော အမြဲမေးခွန်းများ",
    "SHOW_MORE_ARTICLE": "ပိုမို ဝက်ဘ်စာမျက်နှာများကို ပြသပါ",
    "SHOW_LESS_ARTICLE": "ငယ်ရွယ်သော ဝက်ဘ်စာမျက်နှာများ",
    "SHOW_MORE_SNIPPET": "ပိုမို တုံ့ပြန်ချက်များကို ပြသပါ",
    "SHOW_LESS_SNIPPET": "ငယ်ရွယ်သော တုံ့ပြန်ချက်များ",
    "SHOW_MORE_FILES": "ပိုမို ဖိုင်များကို ပြသပါ",
    "SHOW_LESS_FILES": "ငယ်ရွယ်သော ဖိုင်များ",
    "VIEW_ALL_DIALOG": "စကားပြောမှုများအားလုံးကို ကြည့်ပါ",
    "VIEW_FEW_DIALOG": "အချို့သော စကားပြောမှုများကို ကြည့်ပါ",
    "HELP_FULL": "အကူအညီ ရှိပါသလား?",
    "THANKYOU": "ကျေးဇူးတင်ပါတယ်!",
    "EXPAND_MORE": "ချဲ့ထွင်ပါ / ပိုမို",
    "CLOSE_TEXT": "ပိတ်ပါ",
    "STARTED": "စတင်ခဲ့သည်",
    "ENDED": "ပြီးခဲ့သည်",
    "VIEW_FULL_ARTICLE": "ဝက်ဘ်စာမျက်နှာကို ကြည့်ပါ",
    "VIEW_FULL_FILE": "ဖိုင်ကို ကြည့်ပါ",
    "COPIED": "ကူးယူပြီး",
    "SENTI_ANALY": "သဘောထားခွဲခြမ်းစိတ်ဖြာ",
    "WRONG_SUGGESTION": "မှားယွင်းသော အကြံပြုချက်",
    "INCORRECT_INTENT": "မှားယွင်းသော သဘောထား",
    "ACCIDENTAL_CLICK": "ကွင်းဆက်ကြောင်းမဲ့ သွားလာမှု",
    "TIME_TAKING": "အချိန်ယူရသည်",
    "OTHER": "အခြား",
    "PLAYBOOK_EMPTY_MSG": "ကစားစာရင်းကို ရွေးချယ်ပါ",
    "PLAYBOOK_EMPTY_DESC": "အေဂျင် AI သည် ကစားစာရင်းများကို ချိန်းလုပ်မရပါ၊ အထူးသဖြင့် ရရှိနိုင်သော ကစားစာရင်းများအားလုံးသည် ပြောင်းလဲမှုများဖြစ်ပါသည်။ 'ကစားစာရင်းရွေးချယ်ရန်' နှိပ်ပါ။",
    "STAGE": "အဆင့်",
    "PROCEED_TO_CLOSE": "ပိတ်ရန် ဆက်လက်ပါ",
    "RECOMENDED_PLAYBOOK": "သိမ်းဆည်းထားသော ကစားစာရင်း",
    "PRIMARY_SCRIPTS": "ဦးဆောင်လက်စွဲ",
    "DYNAMIC_SCRIPTS": "ပြောင်းလဲမှုများ",
    "RESUME": "စတင်ပါ",
    "ENABLE_CLOSE": "ပိတ်မည့် အဆင့်ကို ဖွင့်ရန် ဆက်လက်လုပ်ပါ",
    "LIST_VIEW": "စာရင်းပုံစံ",
    "TERMINATE": "ရပ်ဆိုင်းပါ",
    "MINIMIZE": "သေးငယ်စေပါ",
    "MAXIMIZE": "လှည့်ပါ",
    "NO_SEARCH_RESULT": "မရရှိသော ရှာဖွေမှုရလဒ်",
    "SENTIMENT_AWAITING": "သဘောထားကို စောင့်နေပါသည်",
    "POSITIVE": "အပေါင်း",
    "NEGATIVE": "အနုတ်",
    "ASSOCIATED_WORK_NOTES": "အတူတူ ရှင်းလင်းချက်များ",
    "AGENT_JOINED_CONV": "အေဂျင်သည် စကားပြောမှုသို့ ဝင်ရောက်သည်",
    "AUTOSCROLL_ASSIST": "Auto-Scroll ကူညီမှု Tab အကြောင်းအရာ",
    "FILE_SIZE_MSG": "ဖိုင်အရွယ်အစားသည် 25MB အတွင်းရှိရမည်။ ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ။",
    "OVERRIDE_BTN": "ဖျက်စီးရန်",
    "CHOOSE_FILE": "ဖိုင်ရွေးချယ်ပါ",
    "SUMMARY_ERROR_TEXT": "ကျွန်ုပ်တို့သည် ဤစကားပြောမှုအတွက် အကျဉ်းချုပ်ပြုလုပ်ရာတွင် ပြဿနာတစ်ခု ရှိခဲ့သည်။ ကျေးဇူးပြု၍ သင့်ကိုယ်ပိုင် အကျဉ်းချုပ်ကို ဖန်တီးပါ",
    "ASK_A_QUESTION": "မေးခွန်းတစ်ခု မေးပါ",
    "COPY": "ကူးပါ",
    "TELL_US_MORE": "ကျွန်ုပ်တို့ကို ပိုမိုပြောပါ...",
    "THANKS_FEEDBACK": "သင်၏ အကြံပြုချက်အတွက် ကျေးဇူးတင်ပါသည်",
    "SOMETHING_WRONG": "အခုတလော မဟုတ်တာဖြစ်နေပါတယ်",
    "CLICK_ERROR_DETAILS": "အမှားအကြောင်းအရာကို ကြည့်ရန် နှိပ်ပါ",
    "NO_ACTIVE_PLAYBOOK": "စက်မှုတ်ထားသော ကစားစာအုပ်မရှိပါ",
    "REPHRASE_QUESTION": "သင်၏မေးခွန်းကို ပြန်လည်ဖျော်ဖြေရန် သို့မဟုတ် အခြားအရာတစ်ခုမေးရန် ဖြစ်နိုင်ပါသလား?",
    "INTERNAL_INFO": "အတွင်းရေးရာ အချက်အလက်များ",
    "SOURCES": "အရင်းအမြစ်များ",
    "CONVERSATION_SUMMARY": "စကားပြောမှု အကျဉ်းချုပ်",
    "WAITING": "စောင့်ဆိုင်းနေသည်",
    "WIDGET_DISABLED": "ဝိဇ္ဇာမဟုတ်သည်",
    "AI_SETTINGS_DISABLED": "AI စီမံခန့်ခွဲမှုကို ဖျက်လိုက်ပါ! AI အုပ်ချုပ်သူထံ ဆက်သွယ်ပါ",
    "SERVER_CONNECTION_ERROR": "ဆာဗာနှင့် ချိတ်ဆက်စဉ် အမှား",
    "VIEW": "ကြည့်ပါ",
    "ATTACHMENT_INPUT": "အဆက်အသွယ်ထည့်ပါ",
    "TYPE_SUMMARY": "အကျဉ်းချုပ်ကို ရိုက်ထည့်ပါ",
    "VIEW_FULL_ARTICLE_2": "ပြည့်စုံသော ဆောင်းပါးကို ကြည့်ပါ",
    "VIEW_FULL_FILE_2": "ပြည့်စုံသော ဖိုင်ကို ကြည့်ပါ",
    "BY":"၏",
    GENERATE_SUMMARY: "အကျဉ်းချုပ် ထုတ်လုပ်ပါ",
    PREV_SUMMARIES: "ယခင်ထုတ်လုပ်ထားသော အကျဉ်းချုပ်များ",
    DIALOG_WORKFLOWS: "ဒိုင်ယာလော့ဂ် လုပ်ငန်းစီးပွားများ",
    SHOW_ALL_DIALOG: "ဒိုင်ယာလော့ဂ် အလုပ်အကိုင်များအားလုံးကို ပြပါ",
    SHOW_ALL_DIALOGS: "ဒိုင်ယာလော့ဂ်များအားလုံးကို ပြပါ",
    CUSTOM_TAB: "စိတ်ကြိုက် တက်ဘ်",
    AGENT_INPUT: "အေဂျင် ထည့်သွင်းပါ",
    "CUSTOM_EMPTY_MSG" : "အလိုအလျောက် အလုပ်အကိုင်မရှိပါ",
    "CUSTOM_TAB_DESC" : "အလုပ်အကိုင်ကို စတင်ရန် စက်ပစ္စည်းအောက်တွင် ရှိသော စာရင်းများထဲမှ တစ်ခုကို အလုပ်အကိုင်ပြုပါ။",
    "SUBMIT_OVERALL_FEEDBACK" : "အကျဉ်းချုပ်များအားလုံးကို ပြုပြင်ပါ",
    "FEEDBACK_POPUP_SUBTITLE" : "အလုပ်အကိုင်အားလုံးကို ပြုပြင်ပါ",
    "FEEDBACK_SATISFIED" : "အကျဉ်းချုပ်များအားလုံးကို ပြုပြင်ပါ",
    "FEEDBACK_UNSATISFIED" : "အကျဉ်းချုပ်များအားလုံးကို ပြုပြင်ပါ",
    "FEEDBACK_PROVIDE_REASONS" : "အကျဉ်းချုပ်များအားလုံးကို ပြုပြင်ပါ",
    "FEEDBACK_TITLE" : "အကျဉ်းချုပ်များအားလုံးကို ပြုပြင်ပါ",
    "AGENTIC_THINKING" : "စဉ်းစားနေသည်",
    "AGENTIC_AGENT_TITLE" : "ကိုယ်စားလှယ်",
    "AGENTIC_COPILOT_MODE_TITLE" : "ကိုယ်စားလှယ် Copilot Mode",
    "AGENTIC_SENDING_MESSAGE" : "ပို့နေသည်...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot သည် သင်၏စကားပြောဆိုမှုကို တက်ကြွစွာ နားထောင်နေပြီး အလိုအလျောက် ကူညီရန် အဆင်သင့်ဖြစ်နေသည်",
    "AGENTIC_SEARCH_RESULTS" : "ကိုယ်စားလှယ် ရလဒ်များ"
}